import React from "react";
import Link from "../../components/link"
import Image from "../../components/image"
import { CTAButtonV2 } from '../../components/ctabutton';

import { getLanguageField } from "../../utils/language";
import type { SplitGridProps } from "./types";
import { ModuleHeadV2 } from "src/components/moduleHead/moduleHead.v2";

//@ts-ignore
import * as styles from "./overlay.module.scss";

export default class SplitGrid extends React.Component<SplitGridProps> {

  get verticalAlignment(){
    const { vertical_alignment } = this.props.item;
    return vertical_alignment === "top" ? "items-start" : vertical_alignment === "bottom" ? "items-end" : "items-center";
  }

  get isFullWidth() {
    return this.props.item.width === 'full_screen';
  }

  get boxedText(){
    const { boxed_content } = this.props.item;
    return boxed_content === "text";
  }

  get innerPadding(){
    if (this.boxedText) return "p-6 sm:p-9";
    return "";
  }

  get wrapperPadding(){
    if (!this.isFullWidth) return "py-8";
    return "";
  }

  get boxedBackgroundColor(){
    if (this.boxedText) return this.props.item.boxed_background_color?.value;
    return undefined;
  }

  get rounded(){
    const { rounded_corners, boxed_content } = this.props.item;
    return rounded_corners && boxed_content === "text" ? "rounded-2xl" : "";
  }

  render() {
    const moduleData: { [key: string]: any }   = {
      title: getLanguageField(this.props?.item?.translations, this.props.selectedLanguage, "title"),
      subtitle: getLanguageField(this.props?.item?.translations, this.props.selectedLanguage, "subtitle"),
      description: getLanguageField(this.props?.item?.translations, this.props.selectedLanguage, "body", true, true),
      items: this.props?.item?.split_grid_items,
      alignment: this.props.item.text_position,
      itemTextPosition: "text-" + (this.props.item.item_text_position || "center"),
      overlay: this.props.item.overlay,
      style: this.props.item?.style,
      overlayColor: this.props.item.overlay_item_color?.value,
      overlayOpacity: this.props.item.overlay_opacity || 80,
    }

    const colors = {
      backgroundColor: this.props?.item?.background_color?.value || null,
      bodyColor: this.props?.item?.body_color?.value || "grey",
      titleColor: this.props?.item.title_color?.value,
      subtitleColor: this.props?.item.subtitle_color?.value || "grey",
      imageLabelColor: this.props?.item?.item_label_color?.value || "white"
    }

    const overlayColorWithTransparency = moduleData.overlay ? moduleData.overlayColor + Math.floor( moduleData.overlayOpacity / 100 * 255 || 0 * 255).toString(16) : null
    const overlayStyle:any = this.props.item.overlay ? { "--overlayColor": overlayColorWithTransparency} : undefined;

    let roundedStyles = moduleData.style === "rounded_corners" ? 'rounded-2xl' : "";
    const alignment = moduleData.alignment;


    const TextColumn:any = () => <div className={`mx-auto w-full lg:mx-0 ${this.innerPadding} ${this.rounded}`} style={{ backgroundColor: this.boxedBackgroundColor }}>
      <ModuleHeadV2
        title={moduleData.title}
        subtitle={moduleData.subtitle}
        description={moduleData.description}
        color_title={colors.titleColor}
        color_subtitle={colors.subtitleColor}
        color_description={colors.bodyColor}
      />
        <div className={`mt-2 lg:mt-8 flex flex-col md:flex-row items-center gap-x-6 gap-y-4 md:gap-y-0`}>
          { this.props.item.primary_cta ? <CTAButtonV2
            className="w-full md:w-auto mt-4 md:mt-0"
            language={this.props.selectedLanguage}
            defaultLanguage={this.props.defaultLanguage}
            ctabutton={this.props.item.primary_cta} /> : null }
          { this.props.item.secondary_cta ? <CTAButtonV2
            className="w-full md:w-auto"
            language={this.props.selectedLanguage}
            defaultLanguage={this.props.defaultLanguage}
            ctabutton={this.props.item.secondary_cta} /> : null }
          { this.props.item.soft_cta ? <CTAButtonV2
            className="w-full md:w-auto"
            language={this.props.selectedLanguage}
            defaultLanguage={this.props.defaultLanguage}
            ctabutton={this.props.item.soft_cta} /> : null }
        </div>
      </div>

    const FirstTextColumn = alignment === "left" ? TextColumn : () => <div className={`flex lg:hidden`}><TextColumn/></div>;
    const SecondTextColumn = alignment === "right" ? TextColumn : () => null;

    return (
      <div className={`w-full max-w-7xl mx-auto ${this.wrapperPadding}`} style={{ color: "black" }}>
        <div className="" style={overlayStyle}>
          <div className={`grid grid-cols-1 gap-x-8 gap-y-16 lg:grid-cols-2 ${this.verticalAlignment}`}>
            <FirstTextColumn />
            <div className="mx-auto grid w-full grid-cols-1 md:grid-cols-2 items-center gap-y-6 gap-x-6 lg:mx-0">
              {
                moduleData.items && moduleData.items.length ?
                  moduleData.items.map((image: any, idx: number) => {
                    const link = getLanguageField(image.item?.translations, this.props?.selectedLanguage, "link")
                    const imageLabel = getLanguageField(image.item?.translations, this.props?.selectedLanguage, "label")
                    const imgStyles = moduleData.items.length === 1 ? "col-span-2" : ""
                    const Wrapper = link ? Link : (props: any) => <div {...props} />;
                    return <div className={`relative flex ${imgStyles}`} key={`image-${idx}`}>
                      <Wrapper href={link} className={`w-full object-contain object-left  aspect-w-3 aspect-h-2 relative`}>
                        <Image
                          backgroundColor=""
                          imgStyle={null}
                          className={roundedStyles}
                          src={image.item.image.imageFile}
                          alt={image.item.image.title + ''}
                        />
                      <div className={styles.overlay + ` absolute inset-0 bg-[color:var(--overlayColor)]`} />
                      </Wrapper>
                      <div className="absolute pointer-events-none bottom-6 left-6 right-6 font-bold" style={{ color: colors.imageLabelColor }}>
                        <div className={`w-full ${moduleData.itemTextPosition}`}>{imageLabel}</div>
                      </div>
                    </div>
                  })
                  : null
              }
            </div>
            {
              alignment === "right" ?
                <div className={`hidden lg:flex`}>
                  <SecondTextColumn />
                </div>
                : null
            }
          </div>
        </div>
      </div>
    )
  }
}